<template>
  <v-dialog
    v-model="active"
    persistent
    width="80%"
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Lista de programaciones
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <evaluado-info-card-component :expediente="expediente" />
            </v-col>
          </v-row>
          <v-row v-if="programaciones.length > 0">
            <v-col
              v-for="programacion in programaciones"
              :key="programacion.idProgramacionEvaluacion"
              cols="12"
            >
              <v-card
                class="card"
                color="primary"
              >
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <div class="text-subtitle-1 font-weight-bold">
                          Información de solicitud
                        </div>
                        <div class="text-subtitle-2">
                          Número de oficio de solicitud: {{ programacion.Solicitud.oficio }}
                        </div>
                        <div class="text-subtitle-2">
                          Fecha de solicitud: {{ programacion.Solicitud.fecha }}
                        </div>
                        <div class="text-subtitle-2">
                          Asunto: {{ programacion.Solicitud.asunto }}
                        </div>
                        <div class="text-subtitle-2">
                          Descripción: {{ programacion.Solicitud.descripcion }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model.number="programacion.folio"
                          label="Folio"
                          type="number"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model="programacion.oficioProgramacion"
                          label="Oficio programación"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                        />
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="programacion.fk_idCatMotivoEvaluacion"
                          label="Motivo de evaluación"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                          :items="motivoEvaluacion"
                          item-text="title"
                          item-value="id"
                          item-color="secondary"
                        />
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="programacion.fk_idCatEstatusProgramacion"
                          label="Estatus de evaluación"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                          :items="estatusProgramacion"
                          item-text="title"
                          item-value="id"
                          item-color="secondary"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-btn
                    color="secondary"
                    :disabled="loading"
                    :loading="loading"
                    @click="triggerUpdateProgramacion(programacion)"
                  >
                    Guardar cambios
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-subtitle-1 font-weight-bold">
                No hay programaciones registradas.
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import EvaluadoInfoCardComponent from '../EvaluadoInfoCardComponent.vue';

export default {
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    active: {
      type: Boolean,
    },

    expediente: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters('programacionEvaluacion', {
      programaciones: 'getProgramacionesEvaluacionesPersonal',
    }),

    ...mapGetters('estatusProgramacion', {
      estatusProgramacion: 'getEstatusProgramacion',
    }),

    ...mapGetters('motivoEvaluacion', {
      motivoEvaluacion: 'getMotivoEvaluacion',
    }),
  },

  methods: {
    ...mapActions('programacionEvaluacion', ['updateProgramacionEvaluacion']),

    closeDialog() {
      this.$emit('close');
    },

    async triggerUpdateProgramacion(programacion) {
      this.loading = true;
      await this.updateProgramacionEvaluacion(programacion);
      this.loading = false;
    },
  },
};
</script>
